import { c as _c } from "react/compiler-runtime";
import Image, { ImageProps } from 'next/image';
export default function ImageCdn(t0) {
  const $ = _c(6);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      alt: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const alt = t1 === undefined ? "" : t1;
  let t2;
  if ($[3] !== alt || $[4] !== props) {
    t2 = <Image alt={alt} {...props} />;
    $[3] = alt;
    $[4] = props;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}